module.exports = __webpack_public_path__ + "static/headshot-5c1e4d7e234e5cae3b3eede66b6ec36b.jpeg";